import React from 'react';
import { ButtonWithContentCard } from './layouts/ButtonWithContentCard';
import { ButtonWithContentSection } from './layouts/ButtonWithContentSection';

const ButtonWithContent = ({ card, fields }) => {
  return <>{card ? <ButtonWithContentCard fields={fields} /> : <ButtonWithContentSection fields={fields} />}</>;
};

export { ButtonWithContent };
